"use client";
import { useEffect } from "react";

export default function ClientErrorHandler() {
    useEffect(() => {
        const listener = () => {
            if (e?.message?.includes("Loading chunk")) {
                console.warn("ChunkLoadError detected. Reloading...");
                window.location.reload(); // fallback reload
            }
        };
        window.addEventListener("error", listener);
        return () => window.removeEventListener("error", listener);
    }, []);

    return null; // This component renders nothing
}
